$(function() {
    var accItem = document.getElementsByClassName('helpBox');
    var accHD = document.getElementsByClassName('-js-show');
    for (i = 0; i < accHD.length; i++) {
        accHD[i].addEventListener('click', toggleItem, false);
    }

    function toggleItem() {
         var itemClass = this.parentNode.className;

         if (itemClass == 'helpBox close-help mt20') {
             for (i = 0; i < accItem.length; i++) {
                 accItem[i].className = 'helpBox close-help mt20';
             }
             this.parentNode.className = 'helpBox open active mt20';
         } else {
             this.parentNode.className = 'helpBox close-help mt20';
         }
    }
});